<template>
  <div class="alls">
    <div class="tops hovers" id="topss">
      <p><span @click="returns()"  class="">首页</span><span><img src="../assets/you.png" alt=""></span><span class="lastspan">招贤纳士 </span></p>
    </div>
    <div class="centers">
        <h3>网站正在建设</h3>
        <div class="btns hovers">
          <p @click="returns()"  class="hovers">回主页</p>
        </div>
        <div class="suanglun boxs">
          <img src="../assets/shaungzhou.png" alt="">
        </div>
        <div class="danlun boxs">
          <img src="../assets/danzhou.png" alt="">
        </div>
        <div class="gaizhui boxs">
          <img src="../assets/gaizhui.png" alt="">
        </div>
        <div class="banshou boxs">
          <img src="../assets/banshou.png" alt="">
        </div>
        <div class="wenhao boxs">
          <img src="../assets/wenhao.png" alt="">
        </div>
    </div>
  </div>
</template>

<script>
// import { useRouter } from "vue-router";
// const router = useRouter();
export default {
  data() {
    return {}
  },
  methods: {
    returns(){
      this.$router.push({ path: "/" })
    }
  },
  created() { },
  mounted() { }
}
</script>

<style scoped>
.tops p {
  padding-left: 5%;
  /* background: yellow; */
  box-sizing: border-box;
  padding-top: 1rem;
  padding-bottom:1rem;
  font-size: 0.6rem;
}

.tops p img {
  width: 0.6rem;
}

.tops p span {
  margin-right: 0.8rem;
  /* color: #3b3c3c; */
  color: #9c9c9c;
}

.tops p .lastspan {
  color: #3b3c3c;
}
.centers{
  /* height: 85vh; */
  padding: 10rem 0;
  /* border: 1px solid red; */
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.btns{
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translateX(-50%);
  /* border: 1px solid red; */
  padding: 0.7rem 1.8rem;
  background: #2180D1;
}
.btns p{
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  color: #f1f9ff;
  letter-spacing: 0.2rem;
  text-indent: 0.2rem;
}
.centers h3{
  font-size: 2rem;
  /* line-height: 80vh; */
  letter-spacing: 0.2rem;
  text-indent: 0.2rem;
}
.boxs{
  position: absolute;
}
.boxs img{
  width: 100%;
}
.suanglun{
  /* position: absolute; */
  top: 7%;
  left: 50%;
  transform: translateX(-50%);
  width: 12%;
}
.banshou{
/* background: yellow; */
right: 10%;
top: 20%;
width: 25%;
transform-origin:14% 13%;
/* background: yellow; */
transform: rotateZ(-20deg);
animation:  rotate30 2.5s linear  infinite;
}
.wenhao{
  right: 25%;
  bottom: 15%;
  width: 6%;
}
.gaizhui{
  left: 20%;
  top: 50%;
  width: 4%;
  transform: translateY(-50%);
}
@keyframes rotate360 {
        100% {
            transform: rotateZ(360deg);
        }
    }
    @keyframes rotate30 {
      0% {
        transform:  rotateZ(-20deg) ;

        }
        10% {
          transform:  rotateZ(-12deg) ;
        }
        20% {
          transform:  rotateZ(-4deg) ;
        }
        30% {
          transform:  rotateZ(4deg) ;
        }
        40% {
          transform:  rotateZ(8deg) ;
        }
        50% {
          transform:  rotateZ(8deg) ;
        }
        60% {
          transform:  rotateZ(8deg) ;
        }
        70% {
          transform:  rotateZ(1deg) ;
        }
        80% {
          transform:  rotateZ(-6deg) ;
        }
        90% {
          transform:  rotateZ(-13deg);
        }
        100% {
          transform:  rotateZ(-20deg) ;
        }
    }
   
.danlun{
  left: 25%;
  width: 8%;
  bottom: 10%;
  animation:  rotate360 5s linear  infinite;
  
}




</style>